module.exports = __webpack_public_path__ + "assets/img/history.22d87e3c.svg";